<template>
  <div class="bo-outer" ref="kakiNavBar" :style="kakiNavBarCss">
    <div class="bo">
      <div
        class="tab"
        :class="[{ tab: true, active: item.active }]"
        v-for="(item, index) in tabs"
        :key="item.id"
        @click="tabClick(item, index)"
        :title="item.title"
      >
        <div class="left"></div>
        <div class="inner">
          <div class="title">{{ item.title }}</div>
          <div
            v-if="index !== 0"
            class="clear"
            @click.self.stop="delTabBar(item, index)"
          >
            +
          </div>
        </div>
        <div class="right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import showCurrentApp from '@/utils/showCurrentApp.js'

export default {
  computed: {
    kakiNavBarCss() {
      return {
        '--nav-bar-color--active': this.navBarActiveColor,
        '--nav-bar-color': this.navBarColor,
      }
    },
    activeTab() {
      return (i) => {
        console.log(this.activeTabIndex, i)
        return this.activeTabIndex === i ? 'active1' : ''
      }
    },
  },
  data() {
    return {
      activeTabIndex: 0,
      navBarColor: '',
      navBarActiveColor: '',
      microApp: null,
      tabs: [],
    }
  },
  watch: {
    '$store.state.tabs': function () {
      this.tabs = this.$tabs.tabs
    },
  },
  methods: {
    async tabClick(el, index) {
      this.activeTabBar(index)
      // 切换页签
      if (el.id === this.$tabs.activeTab.id) return // 点击的是当前页签
      await this.$tabs.switchTab(el)
      this.$nextTick(() => {
        showCurrentApp()
      })
    },
    closeOtherClickAble(el) {
      let tabs = [...this.tabs]
      return tabs.some((item) => {
        return item.path !== el.path && item.closeAble
      })
    },
    closeAllClickAble() {
      let tabs = [...this.tabs]
      return tabs.some((item) => {
        return item.closeAble
      })
    },
    rightMenuObj(item) {
      let _this = this
      let menus = [
        {
          label: '重新加载',
          handler() {
            _this.$tabs.reloadTab(item)
          },
          clickAble: item.active,
        },
        {
          label: '关闭',
          handler() {
            _this.$tabs.closeTab(item)
            // _this.closeTab(item)
          },
          clickAble: item.closeAble,
        },
        {
          label: '关闭其他',
          handler() {
            _this.$tabs.closeOtherTabs(item)
          },
          clickAble: this.closeOtherClickAble(item),
        },
        {
          label: '关闭全部',
          handler() {
            _this.$tabs.closeAllTabs(item)
          },
          clickAble: this.closeAllClickAble(),
        },
      ]
      return menus
    },
    delTabBar(item, index) {
      if (this.activeTabIndex === index) {
        this.activeTabIndex = index - 1
      }
      this.$tabs.closeTab(item)
      // 关闭tab后，展示最后一个页签的tab
      setTimeout(() => {
        showCurrentApp()
      }, 10)
    },
    activeTabBar(index) {
      this.activeTabIndex = index
    },
    navbarMenuScroll(e) {
      e.preventDefault()
      const kakiNavBar = this.$refs.kakiNavBar
      if (e.wheelDelta > 0) {
        // 向上滚动
        kakiNavBar.scrollLeft = kakiNavBar.scrollLeft - 50
      }
      if (e.wheelDelta < 0) {
        // 向下滚动
        kakiNavBar.scrollLeft = kakiNavBar.scrollLeft + 50
      }
    },
  },
  mounted() {
    this.tabs = this.$tabs.tabs
    const kakiNavBar = this.$refs.kakiNavBar
    kakiNavBar.addEventListener('wheel', this.navbarMenuScroll, false)
  },
  destroyed() {
    const kakiNavBar = this.$refs.kakiNavBar
    kakiNavBar.removeEventListener('wheel', this.navbarMenuScroll, false)
  },
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/global.scss';
.bo {
  width: fit-content;
  height: 100%;
  display: inline-flex;
  flex-flow: row nowrap;
  &-outer {
    @include scrollbar(0);
    width: 100%;
    height: 30px;
    padding: 0 12px;
    margin: 0 6px;
    overflow: auto;
    background: #e9edf3;
  }
}
.tab {
  width: 124px;
  height: 30px;
  position: relative;
  background: #e9edf3;
  cursor: pointer;
  & + & {
    margin-left: 12px;
  }
  &.active {
    .inner,
    .left,
    .right {
      background: #fff;
      transition: all 0.7s;
    }
    .inner {
      .title {
        color: #477dff;
      }
      .clear {
        &:hover {
          background: #d6dae3;
        }
      }
    }
  }
  .inner {
    width: 100%;
    height: 100%;
    background: #d6dae3;
    border-radius: 12px 12px 0 0;
    text-align: center;
    position: relative;
    padding: 0 12px;
    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 6px;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
      color: #666;
    }
    .clear {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 3px;
      transform: translateY(-50%) rotate(45deg) scale(1);
      width: 15px;
      height: 15px;
      border-radius: 50%;
      font-size: 14px;
      text-align: center;
      &:hover {
        background: #c0c4cc;
      }
    }
  }
  .left,
  .right {
    position: absolute;
    width: 6px;
    height: 30px;
    background: #d6dae3;
    overflow: hidden;
  }
  .left {
    left: -6px;
    &::before {
      content: '';
      position: absolute;
      width: 12px;
      height: 30px;
      left: -6px;
      border-radius: 0 0 12px 0;
      background: #e9edf3;
    }
  }
  .right {
    right: -6px;
    bottom: 0;
    &::before {
      content: '';
      position: absolute;
      width: 12px;
      height: 30px;
      right: -6px;
      border-radius: 0 0 0 12px;
      background: #e9edf3;
    }
  }
}
</style>
